import { tx } from "shared/types/i18n";

import { DataCollectionImplementation } from "../types";
import { FormCheckboxInput } from "~/components/form/form-checkbox-input";
import { Link } from "~/components/link";

export const termsAndConditions20230830Input: DataCollectionImplementation = {
  wasCompleted: (user) =>
    !!user.userAttributes?.agreedToTermsAndConditions20230830,
  Component: ({ errors, register }) => {
    return (
      <div>
        <FormCheckboxInput
          labelClassName="font-bold"
          title={{ tx: "signUp.customFields.mamaTermsAndConditions.title" }}
          label={{
            tx: "signUp.customFields.mamaTermsAndConditions.agreeToTermsAndConditions",
            txComponents: {
              href: <Link target="_blank" className="underline" />,
            },
          }}
          {...register("agreedToTermsAndConditions20230830", {
            required: tx(
              "signUp.customFields.mamaTermsAndConditions.errorUserDidNotAgreeToTermsAndConditions",
            ),
          })}
          error={{
            txUnchecked: errors.agreedToTermsAndConditions20230830?.message,
          }}
        />
      </div>
    );
  },
};
